"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoClearColumnCommand = void 0;
const clear_column_action_1 = require("../../actions/clear-column-action");
class AutoClearColumnCommand {
    static isCommand(command) {
        return command instanceof AutoClearColumnCommand;
    }
    constructor(columnId, entitiesManager, eventQueue) {
        this.columnId = columnId;
        this.entitiesManager = entitiesManager;
        this.eventQueue = eventQueue;
    }
    executeCommand(_commandHash, instant) {
        const clearColumnAction = new clear_column_action_1.ClearColumnAction(this.entitiesManager.board, this.columnId);
        clearColumnAction.execute();
        clearColumnAction.resolve();
        this.eventQueue.enqueue({
            type: "onColumnCleared",
            instant,
            payload: {
                cardColumn: this.entitiesManager.cardColumn(this.columnId).clone(),
            },
        });
        return Promise.resolve();
    }
}
exports.AutoClearColumnCommand = AutoClearColumnCommand;
